import React from "react";
import "./breadcrumb.scss";
import { Link } from "gatsby";

const Breadcrumb = ({ breadcrumbLinks }) => {
  return (
    <>
      <ul className="breadcrumb">
        {breadcrumbLinks &&
          breadcrumbLinks.map((item, index) => (
            <li className="item" key={index}>
              <Link
                to={item.uri}
                itemProp="url"
                className="link"
              >
                {item.name}
              </Link>
            </li>
          ))}
      </ul>
    </>
  );
};

export default Breadcrumb;
